import { schoolConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { commonService } from "../_services";
import { alertActions } from ".";

export const schoolActions = {
  getSchoolById,
  saveSchool,
  getSchoolsList,
  deleteSchool
};

function getSchoolById (apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(schoolConstants.SCHOOL_BY_ID_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      schoolData => {        
                        dispatch(commonAction.success(schoolConstants.SCHOOL_BY_ID_SUCCESS, schoolData));
                      },
      error => {
                  dispatch( commonAction.failure(schoolConstants.SCHOOL_BY_ID_FAILURE, error) );                 
               }
      );
  };
}

//-- school save
function saveSchool(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(schoolConstants.SCHOOL_ADDED_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      schoolData => {
        dispatch(commonAction.success(schoolConstants.SCHOOL_ADDED_SUCCESS, schoolData));
      },
      error => {
        dispatch(commonAction.failure(schoolConstants.SCHOOL_ADDED_FAILURE, error));
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}

//-- getSchoolsList
function getSchoolsList(apiName, schoolData) {

  return dispatch => {
      dispatch(
          commonAction.request(schoolConstants.SCHOOL_LIST_REQUEST, schoolData)
      );
      commonService.withToken(apiName, schoolData).then(
          notification => {
              dispatch(
                  commonAction.success(schoolConstants.SCHOOL_LIST_SUCCESS, notification)
              );
          },
          error => {
              dispatch(
                  commonAction.failure(schoolConstants.SCHOOL_LIST_ERROR, error)
              );
              dispatch(alertActions.error(error.response.data.error));
          }
      );
  };
}


//delete school
function deleteSchool(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(schoolConstants.DELETE_SCHOOL_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      schoolData => {
        dispatch(commonAction.success(schoolConstants.DELETE_SCHOOL_SUCCESS, schoolData));
      },
      error => {
        dispatch(commonAction.failure(schoolConstants.DELETE_SCHOOL_FAILURE, error));
      }
    );
  };
}